import { useMemo } from "react";

export const useAccountsStats = (accounts, filteredAccounts, user) => {
  const stats = useMemo(() => {
    const activeAccounts = filteredAccounts.filter(l => !l.isDisabled);
    const totalAccounts = activeAccounts.length;

    // Status Breakdown
    const statusMap = {};
    activeAccounts.forEach(l => {
      const s = l.status || 'new';
      statusMap[s] = (statusMap[s] || 0) + 1;
    });

    const statusBreakdown = Object.entries(statusMap).map(([name, value]) => ({
      name: name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
      value
    })).sort((a, b) => b.value - a.value);

    const appointedCount = activeAccounts.filter(l => 
      l.isConvertedByTelecaller || l.status === 'converted' || l.status === 'appointment_scheduled'
    ).length;

    const approvedCount = activeAccounts.filter(l => 
      ['approved', 'project_started', 'completed'].includes(l.status)
    ).length;

    const unassignedCount = activeAccounts.filter(l => !l.assignedTo).length;

    const conversionRate = totalAccounts > 0 ? Math.round((appointedCount / totalAccounts) * 100) : 0;

    const totalBudget = activeAccounts.reduce((sum, l) => sum + (Number(l.budget) || Number(l.quotationAmount) || Number(l.projectValue) || 0), 0);
    const totalReceived = activeAccounts.reduce((sum, l) => sum + (Number(l.totalReceived) || 0), 0);
    const totalExpenses = activeAccounts.reduce((sum, l) => sum + (Number(l.totalExpenses) || 0), 0);
    const pendingBalance = activeAccounts.reduce((sum, l) => sum + (Number(l.balance) || 0), 0);
    
    const fullyPaid = activeAccounts.filter(l => Number(l.balance) <= 0 && (Number(l.budget) > 0 || Number(l.totalReceived) > 0)).length;

    return {
      total: totalAccounts,
      referrals: unassignedCount, // Unassigned used as referrals in old UI
      newAccounts: statusMap['new'] || 0,
      appointed: appointedCount,
      approvedCount: approvedCount,
      rate: conversionRate,
      budget: totalBudget,
      totalReceived,
      totalExpenses,
      pendingBalance,
      fullyPaid: `${fullyPaid}/${totalAccounts}`,
      statusBreakdown
    };
  }, [filteredAccounts]);

  return stats;
};
